






































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { uploader } from "./utils/uploader.js";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

import { gqlClient } from "@root/apollo/apollo-options";
import { mediaSignature } from "@/graphql/Root.gql";
import ImportDialog from "./ImportDialog.vue";

const Root = namespace("root");
const importX = namespace("import");

const isPromise = p => Object.prototype.toString.call(p) === "[object Promise]";

const isFunction = fn => fn instanceof Function;

const createDownA = url => {
  let eleLink = document.createElement("a");
  eleLink.download = url;
  eleLink.style.display = "none";
  eleLink.href = url;
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
};

@Component({
  components: {
    ImportDialog
  }
})
@SearchbarControl()
@pagination("getData", {
  pageSize: 50
})
@loading()
export default class ImportComponentPage extends Vue {
  @Prop({ type: Boolean, default: true }) requiredOrg;
  // @Prop({ type: Array, required: true }) tabOptions;
  @Prop({ type: String, default: "Import" }) pageTitle;
  @Prop({ type: String, default: "" }) pageSubTitle;
  @Prop({ type: Boolean, default: false }) defaultOrgDisabled; // default org 不可用
  @Prop({ type: Function }) orgCodeCallback; // default org 不可用
  @Prop({ type: String }) template; // default org 不可用

  @Root.State ddCodes;

  @Root.Action downTemplate;
  @Root.Action getSystemValue;
  @importX.Action queryFile;
  @importX.Action importFile;

  private activeName = "";
  private category = "";
  private dataList = [];
  private total = 0;
  private alerted = false;
  private loading = false;
  private detailData = null;
  private uploadFilePath = "";
  private showRules = true;
  private orgCode = "";
  private metaData = [];
  private fileCode = "";

  private isImportVisible = false;
  private templateUrl = "";

  get tabOptions() {
    const apiList = this.ddCodes.K1_IMPORT_FILE_TYPE;
    return [{ label: "全部", value: "" }].concat(apiList);
  }
  created() {
    this.$dd.register(["K1_IMPORT_FILE_TYPE"]).query();
    this.pageInit();
  }

  // 请求用到的 orgCode
  async getSelfDefinedOrgCode() {
    if (this.orgCode) return this.orgCode;
    else {
      let orgCode = localStorage.org || "default";

      if (this.orgCodeCallback && isFunction(this.orgCodeCallback)) {
        let promiseMaybe = this.orgCodeCallback();

        if (isPromise(promiseMaybe)) {
          orgCode = await promiseMaybe;
        } else {
          orgCode = promiseMaybe;
        }
      }

      this.orgCode = orgCode;

      return orgCode;
    }
  }

  pageInit() {
    this.getData();
    this.getSystemVal();
  }

  async getData() {
    this.loading = true;
    try {
      const { category, pageSize, pageNum } = this as any;
      const { data = [], total = 0 } = await this.queryFile({
        fileType: Number(this.activeName) || null,
        pageInput: {
          pageNum,
          pageSize
        }
      });
      this.dataList = data;
      this.total = total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  async downloadClick(template) {
    if (!template) return;
    let url = "";
    // TODO: 创建下载模板链接
    url = this.templateUrl;
    // if (typeof template === "string") {
    //   url = template;
    // } else if (typeof template === "function") {
    //   url = await template();
    // } else {
    //   url = await this.downTemplate(template);
    // }

    url && createDownA(url);
  }

  selectClick(item) {
    if (!this.isImportVisible) return false;
    uploader.setOption({
      errorCallback: this.$message.error,
      filter: "xlsx,csv,xls"
    });
    // 调用 uploader.js 中选择文件的 method
    uploader.selectFile(file => {
      this.uploadFilePath = file["name"];
    });
  }

  removeClick() {
    uploader.removeFile();
    this.uploadFilePath = "";
  }

  @loadingCatch
  async refreshClick() {
    await this.getData();
  }

  async uploadClick() {
    uploader.setOption({
      beforeUploadCallback: this.beforeCallback,
      successCallback: this.successCallback
    });

    uploader
      .upload()
      .then(res => {
        const { activeName } = this;
        const { file, data, fileKey } = res;
        const fileName = file.name || "";
        const fileUrl = data.domain + "/" + fileKey;
        const fileInput = {
          fileName,
          fileUrl,
          fileType: Number(activeName), // 全部不会有上传文件
          type: "0"
        };
        return this.importFile({ input: fileInput });
      })
      .then(() => {
        this.getData();
      });
  }

  // callback
  async onViewClick(row) {
    let {
      fileCode: importNo = "",
      createTime = "",
      fileName: name = "",
      errorSum: errorCount = 0,
      successSum,
      sum: totalCount = 0
    } = row;

    this.detailData = {
      createTime,
      name,
      errorCount,
      importNo,
      successCount: successSum
    };

    this.fileCode = row.fileCode;

    (this.$refs.import as any).dialogTableVisible = true;
  }

  async beforeCallback({ name: fileName }) {
    return await this.getToken();
  }

  async getToken() {
    let res = await gqlClient.query({
      query: mediaSignature,
      variables: { tenantCode: "23r" }
    });
    const data = res.data.mediaSignature;
    return data;
  }

  async successCallback() {
    // 第一次上传文件 会弹出提示文本 只提示一次
    if (!this.alerted) {
      this.$alert((this as any).$t("Root.Import.importing"), {
        confirmButtonText: (this as any).$t("Root.Import.got_it")
      });
    } else {
      this.alerted = true;
    }

    // reset fetch data
    (this as any).handlePageChange(1);

    // hiddle select file path
    this.uploadFilePath = "";
  }

  // utils
  renderHeader(h, { column, $index }) {
    return h("div", [
      h("span", column.label + "  ", {
        align: "left"
      }),
      h(
        "el-popover",
        {
          props: {
            placement: "top-start",
            width: "220",
            trigger: "hover"
          }
        },
        [
          // h("p", "When the import is running,you can not view result", {
          h("p", "导入中无法查看结果", {
            class: "text-align: right; margin: 0"
          }),
          h("i", {
            class: "el-icon-question",
            style: "color:#777;cursor: pointer;",
            slot: "reference"
          })
        ]
      )
    ]);
  }

  onReset() {
    this.activeName = "";
    this.getData();
  }
  async onTabSwitch(val) {
    // this.category = this.tabOptions[index].category;
    this.isImportVisible = !!val;
    (this as any).handlePageChange(1);
  }

  async getSystemVal() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "IMPORT_PRODUCT_URL"
    });
    // return valueValue;
    this.templateUrl = valueValue;
  }
}
